/**
 * Strips the file extension from a filename
 * @param filename the filename to strip the extension from
 * @return {string} the filename without the extension
 */
export default function (filename) {
  return filename.split('.').slice(0, -1).join('.');
}
